"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.goToWithHistory = exports.goToWithContext = void 0;

var _replace = _interopRequireDefault(require("lodash/replace"));

var _flatten = _interopRequireDefault(require("lodash/flatten"));

var _find = _interopRequireDefault(require("lodash/find"));

var _reactRouter = require("react-router");

var _store = _interopRequireDefault(require("./../store"));

var _getActivePage = function _getActivePage(state, pathname) {
  var pathToMath = pathname;

  if (state.basename) {
    pathToMath = (0, _replace["default"])(pathname, state.basename, '');
  }

  var routes = (0, _flatten["default"])(state.availableRoutes.map(function (route, index) {
    if (typeof route === 'function') {
      return route();
    } else {
      return route;
    }
  }));
  return (0, _find["default"])(routes, function (route) {
    var match = (0, _reactRouter.matchPath)(pathToMath, {
      path: route.path || route.pattern,
      // Use path instead of pattern, pattern won't be supported in a next version
      exact: route.exactly,
      strict: route.strict
    });
    return match !== null;
  });
};

var goToWithContext = function goToWithContext(context, path, replace) {
  return goToWithHistory(context.router.history, path, replace);
};

exports.goToWithContext = goToWithContext;

var goToWithHistory = function goToWithHistory(history, path, routeReplace) {
  var state = (0, _store["default"])().getState();

  var page = _getActivePage(state.router, path);

  if (page) {
    var pathToMath = path;

    if (state.router.basename) {
      pathToMath = (0, _replace["default"])(path, state.router.basename, '');
    }

    if (routeReplace) {
      history.replace(pathToMath);
    } else {
      history.push(pathToMath);
    }
  } else {
    window.location.href = path;
  }
};

exports.goToWithHistory = goToWithHistory;
var _default = goToWithContext;
exports["default"] = _default;